export default "__VITE_ASSET__u3q5vLk3__"